<app-close-modal *ngIf="showModal" (closeModal)="closeModal($event)"></app-close-modal>